import React, { FC } from 'react';
import { Switch, Route } from 'react-router-dom';
import Stitching from './Components/StitchingTool/Stitching/Stitching';
import Callback from './Components/Auth/Callback/Callback';
import IdentityError from './Components/Auth/Error/IdentityError';
import Login from './Components/Auth/Login/Login';
import NoMatch from './Components/Shared/NoMatch/NoMatch';
import NotAuthorized from './Components/Auth/NotAuthorized/NotAuthorized';
import { RequireAuth } from './Auth/RequireAuth';
import ATSCases from './Components/Admin/ATSCases';
import TurbineDeepzoomStatus from './Components/Admin/DeepzoomStatus/DeepzoomStatus';
import TurbineThumbnailStatus from './Components/Admin/SequenceProcessStatus/SequenceProcessStatus';
import ParserMiddleware from './Components/AnnotationManager/Annotation/ParserMiddleware';
import AnnotationStandards from './Components/AnnotationManager/AnnotationStandards/AnnotationStandards';
import FindingTypePropertyTemplateTable from './Components/AnnotationManager/FindingTypePropertyTemplate/FindingTypePropertyTemplateTable';
import AnnotationStandardForm from './Components/AnnotationManager/AnnotationStandardForm/AnnotationStandardForm';
import FindingTypeTemplateTable from './Components/AnnotationManager/FindingTypeTemplate/FindingTypeTemplateTable';
import FailureMechanismTemplateTable from './Components/AnnotationManager/FailureMechanismTemplate/FailureMechanismTemplateTable';
import Landing from './Components/Shared/Landing/Landing';
import MaintenanceTriggerPage from './Components/MaintenanceTriggers/MaintenanceTrigger/MaintenanceTriggerPage';
import MaintenanceTriggerTable from './Components/MaintenanceTriggers/MaintenanceTriggers';
import { Permissions } from './shared/models/permissions.enum';
import FailureModeCategoryTemplateTable from './Components/AnnotationManager/FailureModeCategoryTemplate/FailureModeCategoryTemplateTable';
import EightDTemplateTable from './Components/AnnotationManager/EightDTemplate/EightDTemplateTable';

const Main: FC = () => {
  return (
    <React.Fragment>
      <Switch>
        <Route path='/callback' component={Callback} />
        <Route path='/login' component={Login} />
        <Route path='/not-authorized' component={NotAuthorized} />
        <Route path='/identity-error' component={IdentityError} />
        <Route path='/deepzoom/:site/:inspection/:turbine' component={TurbineDeepzoomStatus} />
        <Route path='/thumbnails/:site/:inspection/:turbine' component={TurbineThumbnailStatus} />
        <Route path='/atscases' component={ATSCases} />
        <Route
          path='/stitching-tool/:site'
          render={({ match }) => (
            <Switch>
              <Route
                path={`${match.path}/:inspection`}
                render={({ match }) => (
                  <Switch>
                    <Route path={`${match.path}/:turbine`} component={RequireAuth(Stitching, [Permissions.StitchingTool_General])} />
                    <Route component={NoMatch} />
                  </Switch>
                )}
              />
              <Route component={NoMatch} />
            </Switch>
          )}
        />
        <Route path='/annotation-manager' exact component={RequireAuth(Landing, [Permissions.AnnotationManager_View])} />
        <Route path='/stitching-tool' exact component={RequireAuth(Landing, [Permissions.StitchingTool_General])} />
        <Route
          path='/annotation-manager/finding-type-property-template'
          exact
          component={RequireAuth(FindingTypePropertyTemplateTable, [Permissions.AnnotationManager_AnnotationStandardTemplateAdministration])}
        />
        <Route
          path='/annotation-manager/finding-type-template'
          exact
          component={RequireAuth(FindingTypeTemplateTable, [Permissions.AnnotationManager_AnnotationStandardTemplateAdministration])}
        />
        <Route
          path='/annotation-manager/failure-mechanism-template'
          exact
          component={RequireAuth(FailureMechanismTemplateTable, [Permissions.AnnotationManager_AnnotationStandardTemplateAdministration])}
        />
        <Route
          path='/annotation-manager/failure-mode-category-template'
          exact
          component={RequireAuth(FailureModeCategoryTemplateTable, [Permissions.AnnotationManager_AnnotationStandardTemplateAdministration])}
        />
        <Route
          path='/annotation-manager/eight-d-template'
          exact
          component={RequireAuth(EightDTemplateTable, [Permissions.AnnotationManager_AnnotationStandardTemplateAdministration])}
        />
        <Route
          path='/annotation-manager/annotation-standards/:id'
          exact
          component={RequireAuth(AnnotationStandardForm, [Permissions.AnnotationManager_ViewAnnotationStandard])}
        />
        <Route
          path='/annotation-manager/annotation-standards'
          exact
          component={RequireAuth(AnnotationStandards, [Permissions.AnnotationManager_ViewAnnotationStandard])}
        />
        <Route
          path='/annotation-manager/create-annotation'
          exact
          component={RequireAuth(AnnotationStandardForm, [Permissions.AnnotationManager_CreateAnnotation])}
        />
        <Route
          path='/annotation-manager/create-annotation'
          exact
          component={RequireAuth(AnnotationStandardForm, [Permissions.AnnotationManager_CreateAnnotation])}
        />
        <Route path='/annotation-manager/:parser' component={ParserMiddleware} />
        <Route
          path='/create-maintenance-triggers'
          exact
          component={RequireAuth(MaintenanceTriggerPage, [Permissions.AnnotationManager_AllowMaintenanceTriggersAPICall])}
        />
        <Route
          path='/maintenance-triggers/:id'
          exact
          component={RequireAuth(MaintenanceTriggerPage, [Permissions.AnnotationManager_AllowMaintenanceTriggersAPICall])}
        />
        <Route
          path='/maintenance-triggers'
          exact
          component={RequireAuth(MaintenanceTriggerTable, [Permissions.AnnotationManager_AllowMaintenanceTriggersAPICall])}
        />
        <Route component={NoMatch} />
      </Switch>
    </React.Fragment>
  );
};

export default Main;
